import { IVehicleCategoryPart, IVehicleCategoryPartOffer } from "../../../../data/useVehicleCategoryPartsOptimized";
import { IEbayOffer, ListingDuration } from "../../../../models/EbayOffer";
import { CategoryWithParts, IPart } from "../../../../models/Part";

function toPartOffer(offer: IVehicleCategoryPartOffer, partId: string, created: string, index: number): IEbayOffer {
  return {
    id: `${partId}-offer-${index}`,
    created,
    updated: created,
    publishedOn: null,
    publishedBy: null,
    format: offer.format,
    duration: ListingDuration.GTC,
    condition: null,
    conditionDescription: null,
    listingStarted: null,
    listingEnded: null,
    buyItNowPrice: offer.buyItNowPrice,
    auctionStartPrice: offer.auctionStartPrice,
    auctionReservePrice: null,
    enableBestOffer: null,
    autoAcceptPrice: null,
    locationKey: "",
    buyerCheckoutNotes: null,
    fulfillmentPolicyId: "",
    paymentPolicyId: "",
    returnPolicyId: "",
    sku: "",
    title: "",
    description: "",
    quantity: 1,
    partDataId: partId,
    partData: null,
    ebayId: null,
    categoryId: null,
    storeCategoryId: null,
    saleSource: null,
    paymentStatus: null,
    paymentMethod: null,
    listNow: false,
  };
}

function toPart(part: IVehicleCategoryPart, category: CategoryWithParts["category"]): IPart {
  return {
    id: part.id,
    taskId: 0,
    dataId: null,
    promotionId: null,
    stockNumber: null,
    tagNumber: part.tagNumber,
    title: part.title,
    titleSanitised: part.titleSanitised,
    titleLink: null,
    ebayThumbnail: null,
    cdnThumbnail: part.cdnThumbnail,
    price: part.price,
    suggestedPrice: null,
    enteredPrice: part.enteredPrice,
    marketDataPrice: null,
    marketDataChecked: null,
    lastSoldPrice: null,
    margin: part.margin,
    ebayItemNumber: part.ebayItemNumber,
    ebayTradingApiItemId: part.ebayTradingApiItemId,
    ebayInventoryApiOfferId: part.ebayInventoryApiOfferId,
    activePartOfferId: null,
    vehicleNumber: null,
    isVin: false,
    isInternal: part.isInternal,
    isDamaged: false,
    side: 0,
    position: 0,
    grade: null,
    partNumber: part.partNumber,
    oePartNumber: part.oePartNumber,
    supersededPartNumbers: null,
    partsLookupRequestId: null,
    lastPartLookupChecked: null,
    exactLincNumber: null,
    listedDate: null,
    listingProcessing: null,
    soldDate: part.soldDate,
    processedOn: null,
    removedOn: null,
    removedBy: null,
    passedQcOn: null,
    passedQcBy: null,
    imagedOn: null,
    imagedBy: null,
    pricedBy: null,
    pricedOn: null,
    lastStockChecked: null,
    orderId: null,
    pickedOn: null,
    pickedBy: null,
    shippedOn: null,
    shippedBy: null,
    shippingLabelDocumentId: null,
    trackingNumber: null,
    length: null,
    width: null,
    height: null,
    weight: null,
    fullName: null,
    addressLine1: null,
    addressLine2: null,
    city: null,
    county: null,
    stateOrProvince: null,
    postcode: null,
    partStatus: 0,
    statusMessage: null,
    images: part.images.map((img) => ({
      id: img.id,
      url: img.url,
      thumbnailUrl: img.thumbnailUrl,
      isThumbnail: img.isThumbnail,
      useOnEbay: false,
      order: null,
      partDataId: null,
      imageType: null,
      isEndSlate: false,
      endSlateOrder: null,
      deleted: null,
      created: part.created,
      updated: part.created,
    })),
    offers: (part.offers ?? []).map((offer, index) => toPartOffer(offer, part.id, part.created, index)),
    aspects: [],
    categoryId: category.id,
    category,
    categoryAccepted: false,
    vehicleId: part.vehicleId,
    vehicle: part.vehicleId
      ? {
        id: part.vehicleId,
        combinedMake: part.vehicleCombinedMake,
        combinedModel: part.vehicleCombinedModel,
        vrm: part.vehicleVrm,
        engineModelCode: part.vehicleEngineModelCode,
        dvlaYearOfManufacture: part.vehicleDVLAYearOfManufacture,
      } as any
      : null,
    warehouseLocationId: null,
    warehouseLocation: null,
    shippingPolicyId: null,
    shippingPolicy: null,
    locatedBy: null,
    locatedOn: null,
    notes: [],
    isCore: false,
    internalNotes: [],
    batchItem: null,
    created: part.created,
    updated: part.created,
  };
}

export function mapFetchedCategoryParts(
  categories: CategoryWithParts[],
  expandedCategoryId: string,
  fetchedParts: IVehicleCategoryPart[]
): CategoryWithParts[] {
  return categories.map((cat) => {
    if (cat.category.id !== expandedCategoryId) return cat;

    return {
      ...cat,
      parts: fetchedParts.map((part) => toPart(part, cat.category)),
    };
  });
}
